import { ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter } from '@angular/material/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { DatetimeAdapter, MAT_DATETIME_FORMATS } from '@mat-datetimepicker/core';
import { MAT_MOMENT_DATETIME_FORMATS, MomentDatetimeAdapter } from '@mat-datetimepicker/moment';

@Component({
  selector: 'sc-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter
    },
    {
      provide: DatetimeAdapter,
      useClass: MomentDatetimeAdapter
    },
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: {
        useUtc: true
      }
    },
    {
      provide: MAT_DATETIME_FORMATS,
      useValue: MAT_MOMENT_DATETIME_FORMATS
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatetimePickerComponent),
      multi: true
    }
  ]
})
export class DatetimePickerComponent implements ControlValueAccessor {
  @ViewChild('inputPicker') inputPicker: ElementRef;
  @Input() disabled = false;
  @Input() name: string;
  @Input() minDate: Date;
  @Input() maxDate: Date;

  @Output() public valueChange: EventEmitter<Date> = new EventEmitter();

  private _options = {
    type: 'date',
    format: null
  };

  private _appearance: MatFormFieldAppearance = 'standard';

  private _value: Date;

  constructor(private _cd: ChangeDetectorRef) {}
  @Input() set value(value: Date) {
    this._value = value;
  }
  get value(): Date {
    return this._value;
  }
  @Input() set options(options: { type: string; format: string }) {
    if (options) {
      this._options = options;
    }
  }
  get options() {
    return this._options;
  }

  @Input() set appearance(appearance: MatFormFieldAppearance) {
    if (appearance) {
      this._appearance = appearance;
    }
  }

  get appearance(): MatFormFieldAppearance {
    return this._appearance;
  }

  onChange = (date: Date) => {};
  onTouched = () => {};

  dateChange(value: Date) {
    if (!this.disabled) {
      this.valueChange.emit(value);
      this.writeValue(value);
      this._cd.markForCheck();
    }
  }

  writeValue(value: Date) {
    setTimeout(() => {
      this._value = value;
      this.onChange(value);

      if (this.inputPicker) {
        setTimeout(() => {
          this.inputPicker.nativeElement.blur();
        });
      }
    });
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
